<script lang="ts">
  import { untrack } from 'svelte';
  import { t } from '../../lib/i18n/index.ts';

  // PeriodPicker chooses the stretch Places and Cities cover: all time, a
  // year, or a month (005 FR-039). It sets the query's from and to.
  // start opens it on a year ("2026") or a month ("2026-07"), as Insights
  // had open when one of its categories was picked.
  let { query = $bindable(''), start = '' }: { query?: string; start?: string } = $props();

  const now = new Date();
  // The parent remounts it for a new start, so only the first one counts.
  const initial = untrack(() => start);
  let kind = $state<'all' | 'year' | 'month'>(initial.length === 4 ? 'year' : initial.length === 7 ? 'month' : 'all');
  let year = $state(initial.length >= 4 ? initial.slice(0, 4) : String(now.getFullYear()));
  let month = $state(initial.length === 7 ? initial : `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`);

  $effect(() => {
    if (kind === 'year') {
      query = `&from=${year}-01-01&to=${year}-12-31`;
    } else if (kind === 'month' && month) {
      const [y, m] = month.split('-').map(Number);
      const last = new Date(y, m, 0).getDate();
      query = `&from=${month}-01&to=${month}-${String(last).padStart(2, '0')}`;
    } else {
      query = '';
    }
  });
</script>

<select class="input w-36" bind:value={kind} aria-label={t('timelinePeriod')}>
  <option value="all">{t('timelineAllTime')}</option>
  <option value="year">{t('timelineAYear')}</option>
  <option value="month">{t('timelineAMonth')}</option>
</select>
{#if kind === 'year'}
  <input type="number" class="input w-28" min="2000" max={now.getFullYear()} bind:value={year} aria-label={t('timelineYear')} />
{:else if kind === 'month'}
  <input type="month" class="input w-48" bind:value={month} aria-label={t('timelineMonth')} />
{/if}
